import React, { Component } from 'react';
import './MessageField.scss';

export default class MessageField extends Component {
  render() {
    return <div className="message"> {this.props.field.defaultValue} </div>;
  }
}
